export const environment = {
  production: false,
  // fbAppId: 186848361921511,
  googleWebClientId: '829934903422-n59c8srk5cqrh1qorbbv64sug2hj4vhs.apps.googleusercontent.com',
  firebase: {
    apiKey: "AIzaSyBpfUF9-Pn4q1Vs8bgomqyreElUNUi8WYQ",
    authDomain: "together-28dc1.firebaseapp.com",
    databaseURL: "https://together-28dc1.firebaseio.com",
    projectId: "together-28dc1",
    storageBucket: "together-28dc1.appspot.com",
    messagingSenderId: "829934903422"
  }
};



// WEBPACK FOOTER //
// ./src/environment/environment.ts